"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterElementsActions = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
/**
 * It displays three state a checkbox and allow select all or none elements that respect current search criteria.
 * It also displays a number of elements that respect current search criteria.
 *
 * @beta
 */
exports.AttributeFilterElementsActions = function (props) {
    var checked = props.checked, isVisible = props.isVisible, onChange = props.onChange, onToggle = props.onToggle, isFiltered = props.isFiltered, totalItemsCount = props.totalItemsCount, isPartialSelection = props.isPartialSelection;
    return (react_1.default.createElement(sdk_ui_kit_1.InvertableSelectAllCheckbox, { isVisible: isVisible, checked: checked, onChange: onChange, onToggle: onToggle, isFiltered: isFiltered, totalItemsCount: totalItemsCount, isPartialSelection: isPartialSelection }));
};
//# sourceMappingURL=AttributeFilterElementsActions.js.map